import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  spaceBetween: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  rowStart: {
    alignItems: 'flex-start',
  },
  totalSection: {
    marginTop: theme.spacing[4],
  },
  separator: {
    marginVertical: theme.spacing[4],
  },
}));
